import React from 'react';
import ActionsBlock from './ActionsBlock';
import * as CurrencyUtils from '../../../../../../utils/currency';

export const TableColumns = (mode: 'VIEW' | 'EDIT') => [
  {
    label: '#',
    id: 'vat_return_supply_id',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Fixed Establishment',
    id: 'fixed_establishment',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Type of Supply',
    id: 'supply_type',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Consumer MS',
    id: 'consumer',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Rate',
    id: 'vat_rate',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {CurrencyUtils.formatCurrency(cellValue)}%
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Rate Type',
    id: 'vat_rate_type',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Taxable Amount',
    id: 'taxable_amount',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Amount',
    id: 'vat_amount',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => <ActionsBlock rowIndex={rowIndex} mode={mode} />,
    inData: false,
  },
];
